import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './password.types';
import * as constants from './password.constants';

export const storePassword = generateStoreResourceAction<types.IPassword>(constants.STORE_PASSWORD);
export const clearPassword = generateClearResourceAction(constants.CLEAR_PASSWORD);
